// extracted by mini-css-extract-plugin
module.exports = {"page-container":"PageContainer_page-container__Wm6p3"};